module.exports = __webpack_public_path__ + "static/media/close_search.77c48573.svg";